var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-player__bg",style:({ backgroundImage: 'url(' + _vm.backImageUrl + ')' })})
}
var staticRenderFns = []

export { render, staticRenderFns }